<template>
    <div>
        <kgr-checkbox
            v-for="filter in filters"
            :key="filter.name"
            :label="`${$t(`liveSearch.filter.${filter.name}`)} (${filter.count})`"
            :checked="filter.checked"
            inline
            @change="changed(filter)"
        />
    </div>
</template>

<script>
import Checkbox from '../../common/form/checkbox/Checkbox.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
    },
    props: {
        filters: {
            type: Array,
            required: true,
        },
    },
    methods: {
        changed(filter) {
            this.$emit('changed', filter.name);
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
